import _default from './Loader';
export { _default as default };